import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import IconTicketBoxStyle from '../../assets/icons/IconTicketBoxStyle';

class TicketBoxStyle extends Component {
    render() {
        return (
            <div className={`p-4 ${this.props.textColor}`}>
                <div className="flex items-center">
                    {
                        this.props.loading
                            ? <Skeleton height={40} width={40} />
                            : <div className="h-10 w-10 flex justify-center items-center z-10">{this.props.iconTitle}</div>
                    }
                    {
                        this.props.loading
                            ? <Skeleton height={20} width={120} className="ml-2" />
                            : <div className="ml-2 mt-1 text-xl font-bold uppercase z-10">{this.props.titleTicket}</div>
                    }
                </div>
                <div className="flex absolute bottom-4 z-10">
                    {
                        this.props.loading
                            ? <div className="w-72"><Skeleton height={40} width="100%" /></div>
                            : <div className="h-12 ml-2 flex items-center text-4xl font-normal">
                                {this.props.totalTicket}
                            </div>
                    }
                </div>
                <div className="absolute bottom-0 -left-1">
                    <IconTicketBoxStyle iconFill={this.props.boxIconColor} />
                </div>
            </div>
        );
    }
}

export default TicketBoxStyle;